import { FC, useEffect } from 'react';
import { DownloadIcon } from '@heroicons/react/outline';

import {
  trackProviderEvent,
  AnalyticsPage,
  AnalyticsComponent,
  CommonAnalyticsEvent,
} from '../../../lib/analytics';
import { handleLibraryFormPdfDownload } from '../../lib/pdf';

import Button from '../Button';
import { customToast } from '../ToastAlert/customToast';

const PrintablePdfDownloadButton: FC<{
  blob: Blob | null;
  loading: boolean;
  error: Error | null;
  formName: string;
  assessmentId: string;
}> = ({ blob, loading, error, formName, assessmentId }) => {
  useEffect(() => {
    if (error) {
      customToast.error('Unable to generate PDF. Please try again.');
    }
  }, [error]);

  return (
    <Button
      title={
        loading
          ? 'Generating PDF...'
          : error
          ? 'PDF unavailable'
          : 'Download printable PDF'
      }
      theme="primary"
      size="small"
      IconComponent={DownloadIcon}
      disabled={loading || Boolean(error)}
      onClick={() =>
        handleLibraryFormPdfDownload(blob, formName, () => {
          customToast.success('PDF downloaded successfully');
          trackProviderEvent(CommonAnalyticsEvent.ButtonClicked, {
            buttonName: 'Download printable PDF',
            originPage: AnalyticsPage.Library,
            originComponent: AnalyticsComponent.ActivitySlideover,
            assessmentId,
          });
        })
      }
    />
  );
};

export default PrintablePdfDownloadButton;
